import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import { Slide } from '../../../_data';
import { getSlideField } from 'pages/Conversations/components/SlidesEditor/utils';
import { SlideTitle } from '../slide-title';
import { EditableField } from '../../../components/EditableField';
import { SlideSubtitle } from '../slide-subtitle';
import ModelSetSlideTable, {
  calculateAllStrategyCount,
} from '../../../components/ModelSetSlideTable';
import { ScaledWrapper } from 'pages/Conversations/helpers/ScaledWrapper';

export type ExplanationOfModelsProps = [
  {
    field: 'abbreviated_model_set_name';
    label: string;
    value: string;
    type: 'abbreviated_model_set_name';
  },
  {
    field: 'model_explaination';
    label: string;
    value: string;
    type: 'text';
  },
  {
    field: 'modelSetHoldings';
    label: string;
    value: any[];
    type: 'modelSetHoldings';
  } | null,
  {
    field: 'table_of_contents';
    label: 'Table of Contents';
    value: true;
    type: 'boolean';
  } | null,
];

export const ExplanationOfModels = React.memo(
  ({
    slide,
    onChangeSlide,
  }: {
    slide: Slide<ExplanationOfModelsProps>;
    onChangeSlide: (
      slide: Slide<ExplanationOfModelsProps>,
      content: ExplanationOfModelsProps,
    ) => void;
  }): React.ReactElement => {
    return (
      <Grid container direction="row" className={styles.container}>
        <Grid item xs={12}>
          <SlideTitle>Explanation of Models</SlideTitle>
        </Grid>
        <Grid item>
          <EditableField
            field={'abbreviated_model_set_name'}
            slide={slide}
            onSlideContentChange={onChangeSlide}
            style={{
              fontFamily: 'Roboto',
              fontWeight: '600',
              fontSize: '24px',

              color: '#004F7E',
              margin: '10px 0',
            }}
          />
          <EditableField
            field={'model_explaination'}
            slide={slide}
            onSlideContentChange={onChangeSlide}
            style={{
              fontFamily: 'Roboto',
              fontWeight: '400',
              fontSize: '16px',

              color: '#353536',
              margin: '10px 0',
            }}
          />
        </Grid>
        {getSlideField(slide, 'modelSetHoldings')?.value && (
          <Grid item xs={12}>
            <SlideSubtitle>Strategy Allocations</SlideSubtitle>

            <Grid item xs={12} sx={{ width: '100%', marginTop: '16px' }}>
              <ModelSetField slide={slide} />
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  },
);

const ModelSetField = ({ slide }: any) => {
  const item = getSlideField(slide, 'modelSetHoldings')?.value;
  const strategyCount = calculateAllStrategyCount(item);
  let scale = 1;
  let compactFontSize = '100%';
  switch (true) {
    case strategyCount > 10 && strategyCount <= 15:
      scale = 0.98;
      compactFontSize = '100%';
      break;
    case strategyCount > 15:
      scale = 1.1;
      compactFontSize = '100%';
      break;
    default:
  }
  return (
    <Grid item xs={12}>
      <ScaledWrapper maxHeight={800} scale={scale}>
        <ModelSetSlideTable
          key={
            getSlideField(slide, 'modelSetHoldings')?.value?.model_set_name ||
            ''
          }
          slideMode
          compactFontSize={compactFontSize}
          action={{
            id: '',
            caseId: '',
            userId: '',
            milestoneId: '',
            versionName: '',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            draft: false,
            value: {
              model_set_holdings: [
                getSlideField(slide, 'modelSetHoldings')?.value,
              ],
            },
          }}
          modelSetName={
            getSlideField(slide, 'modelSetHoldings')?.value?.model_set_name ||
            ''
          }
          fontSize={12}
          rowHeight={20}
          enableCollapse={true}
        />
      </ScaledWrapper>
    </Grid>
  );
};
